import { dateNow } from "../../common/date";
import { SAMESITE_VALUES, type SamesiteValues } from "./utils";
import { get as toggleGet } from "../toggle/head.js";

/**
 *
 */
export interface SetCookieOptions {
  /**
 *
 *
 *
 *
 *
 */
  minutes?: number;
  /**
 *
 *
 *
 *
 *
 */
  days?: number;
  /**
 *
 *
 *
 */
  path?: string;
  /**
 *
 *
 *
 *
 */
  domain?: string;
  /**
 *
 *
 *
 */
  samesite?: SamesiteValues;
  /**
 *
 *
 *
 *
 */
  secure?: boolean;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function set<T extends string>(
  cookieName: string,
  cookieValue: T,
  options: SetCookieOptions = {},
): void {
  if (import.meta.env.SSR) return;

  const {
    minutes,
    days,
    path: cookiePath = "/",
    domain,
    samesite,
    secure: cookieSecure = true,
  } = options;

  /*                                                                             */
  /*                                                                                                     */
  /*                                                                 */
  let timeInMinutes = minutes ?? 60;
  if (days) {
    /*                                                                         */
    /*                                                                       */
    if (!minutes) {
      timeInMinutes = 0;
    }

    /*                                                               */
    /*                                                                       */
    timeInMinutes += days * 24 * 60;
  }

  /*                                                                                         */
  const date = dateNow();
  date.setTime(date.getTime() + timeInMinutes * 60 * 1000);

  const cookieParts = [
    `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)}`,
    `expires=${date.toUTCString()}`,
    `path=${cookiePath}`,
  ];

  /*                                                                                          */
  if (domain) cookieParts.push(`domain=${domain}`);
  if (samesite && SAMESITE_VALUES.includes(samesite)) cookieParts.push(`SameSite=${samesite}`);
  if (cookieSecure) cookieParts.push(`Secure`);

  /*                                                                                    */
  document.cookie = cookieParts.join("; ");

  /*                                      */
  if (!toggleGet("LHAS_2048_TRACK_COOKIES", false)) return;

  /*                                     */
  otto.apm.captureError(
    new Error("cookie set has been called"),
    {
      team: "assets",
      service: "global-resources",
      cookieName,
      cookiePath,
      cookieValue,
      cookieSecure,
      cookieExpires: date.toUTCString(),
      cookieDomain: domain ?? -1,
      cookieSameSite: samesite ?? -1,
    },
    { type: "cookie-set" },
  );
}
